import { useState } from "react"
import { Link } from "react-router-dom"
import classNames from "classnames"

import { useAppDispatch, useAppSelector } from "store/hooks"
import { showAccountSettingsModal } from "store/modalSlise"
import { ReactComponent as IconLogout } from "assets/svg/icon-logout.svg"
import { ReactComponent as LockClosed } from "assets/svg/lock-closed.svg"
import { ReactComponent as UserAvatar } from "assets/svg/user-avatar.svg"
import { ReactComponent as Users } from "assets/svg/users.svg"

import { checkRoleType } from "utils/checkRoleType"
import { useLogout } from "hooks/useLogout"

import styles from "./index.module.scss"

export const UserMenu = () => {
  const dispatch = useAppDispatch()
  const logout = useLogout()
  const userProfile = useAppSelector(state => state.user.userProfile)
  const isMasterPassAllowed = [
    "vendor-admin",
    "sales-manager",
    "contractor-admin",
    "contractor-manager",
    "contractor-engineer",
    "contractor-technician",
  ].includes(checkRoleType(userProfile?.type) || "")
  const userManagementAllowed = ["contractor-manager", "contractor-admin"].includes(
    checkRoleType(userProfile?.type) || "",
  )
  const [isDropdownVisible, setDropdownVisible] = useState(false)
  let timeoutId: ReturnType<typeof setTimeout>

  const openDropdown = () => {
    clearTimeout(timeoutId)
    setDropdownVisible(true)
  }

  const closeDropdownOnLeave = () => {
    timeoutId = setTimeout(() => {
      setDropdownVisible(false)
    }, 300)
  }

  const closeDropdownOnClick = () => {
    setDropdownVisible(false)
  }

  const openAccountSettings = () => {
    // check is it contractor type
    if (userProfile?.type === 4 || userProfile?.type === 9) {
      dispatch(showAccountSettingsModal(true))
    }
  }

  return (
    <div
      className={styles.userMenuWrapper}
      onMouseEnter={openDropdown}
      onMouseLeave={closeDropdownOnLeave}
      onTouchStart={openDropdown}
    >
      <figure className={classNames(styles.userMenuButton, { [styles.active]: isDropdownVisible })}>
        <UserAvatar className={styles.userAvatarWhite} />
      </figure>
      <div className={classNames(styles.userDropdown, { [styles.hidden]: !isDropdownVisible })}>
        <div
          className={classNames(styles.userDropdownItem, {
            [styles.skipPointer]: userProfile?.type !== 4 && userProfile?.type !== 9,
          })}
          onClick={openAccountSettings}
        >
          <UserAvatar className={classNames(styles.itemIcon, styles.userAvatarBlack)} />
          <div>
            <div className={styles.userName}>{userProfile?.username}</div>
            <div className={styles.userEmail}>{userProfile?.email}</div>
          </div>
        </div>
        {userManagementAllowed && (
          <Link to="/users" className={styles.userDropdownItem} onClick={closeDropdownOnClick}>
            <Users className={styles.itemIcon} />
            User Management
          </Link>
        )}
        {isMasterPassAllowed && (
          <Link to="/master-pass" className={styles.userDropdownItem} onClick={closeDropdownOnClick}>
            <LockClosed className={styles.itemIcon} />
            Master Pass
          </Link>
        )}
        <div className={styles.userDropdownItem} onClick={logout} data-testid="user-menu-logout">
          <IconLogout className={styles.itemIcon} />
          Log Out
        </div>
      </div>
    </div>
  )
}
